import React from 'react';
import Chart from 'react-apexcharts';

const Areachart = props => {
	const { chartOptions, areaData, xAxisData, id } = props;
	return (
		<Chart
			options={{
				dataLabels: {
					enabled: false,
				},
				colors: ['#3d5afe', '#00e676'],
				xaxis: {
					categories: xAxisData,
				},
				chart: {
					id,
				},
				legend: {
					show: true,
				},
				responsive: [
					{
						breakpoint: 576,
						options: {
							chart: {
								height: 300,
							},
						},
					},
				],
				...chartOptions,
			}}
			series={areaData}
			type="area"
		/>
	);
};

export default Areachart;
